const TYPOGRAPHY_VARIANTS = {
  // Article Typography
  h1: 'article-h1',
  h2: 'article-h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h4',
  h6: 'h4',
  subtitle1: 'article-b1',
  subtitle2: 'article-b2',
  body1: 'body-b1',
  body2: 'body-b2',
  button: 'buttons-m',
  caption: 'body-b4',
  overline: 'body-b4',

  // Extended variants
  'h1-light': 'h1 h1--light',
  'h1-bold': 'h1 h1--bold',
  'h2-light': 'h2 h2--light',
  'h2-bold': 'h2 h2--bold',
  'h2-semibold': 'h2 h2--semibold',
  'h2-caps': 'h2 h2--caps',
  'h2-caps-bold': 'h2 h2--caps h2--bold',
  'h2-caps-semibold': 'h2 h2--caps h2--semibold',
  'h2-caps-light': 'h2 h2--caps h2--light',
  'h3-light': 'h3 h3--light',
  'h3-bold': 'h3 h3--bold',
  'h3-caps': 'h3 h3--caps',
  'h3-caps-bold': 'h3 h3--caps h3--bold',
  'h4-semi': 'h4 h4--semibold',
  'h4-bold': 'h4 h4--bold',
  'h4-caps': 'h4 h4--caps',
  'h4-caps-bold': 'h4 h4--caps-bold',
  body3: 'body-b3',
  'body3-normal': 'body-b3-normal',
  body4: 'body-b4',
  'button-l': 'buttons-l',
  'button-l-bold': 'buttons-l buttons--bold',
  'button-s': 'buttons-s',
  'button-bold': 'buttons-m buttons--bold',
  'button-light': 'buttons-m buttons--light',
  'special-large': 'special-large-text',
  'special-small': 'special-small-text',
}

const TYPOGRAPHY_COMPONENTS = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h3',
  subtitle2: 'h4',
  body1: 'p',
  body2: 'p',
  body3: 'p',
  body4: 'p',
  button: 'span',
  caption: 'span',
  overline: 'span',
  'body3-normal': 'h3',
  'h1-light': 'h1',
  'h1-bold': 'h1',
  'h2-light': 'h2',
  'h2-bold': 'h2',
  'h2-caps': 'h2',
  'h3-light': 'h3',
  'h3-bold': 'h3',
  'h3-caps': 'h3',
  'h3-caps-bold': 'h3',
  'h4-semi': 'h4',
  'h4-bold': 'h4',
  'h4-caps': 'h4',
  'h4-caps-bold': 'h4',
  'button-l': 'span',
  'button-s': 'span',
  'button-bold': 'span',
  'button-light': 'span',
  'special-large': 'p',
  'special-small': 'p',
}

export default function Typography({
  variant = 'body1',
  component,
  className,
  children,
  color = 'text-basic-black',
  ...props
}) {
  const Component = component || TYPOGRAPHY_COMPONENTS[variant] || 'p'
  const variantClassName = TYPOGRAPHY_VARIANTS[variant] || 'body1'

  const combinedClassName = `${variantClassName} ${color} ${className || ''}`.trim()

  return (
    <Component className={combinedClassName} {...props}>
      {children}
    </Component>
  )
}
